const pollosProp = [
  [1, 1],
  [2, 1],
  [3, 0.5],
  [4, 0.25],
  [5, 0.125],
  [6, 1],
  [7, 0.5],
  [8, 0.25],
  [9, 0.125],
  [10, 1],
  [11, 1],
  [12, 0.5],
  [13, 0.25],
  [14, 0.125],
  [15, 1],
  [16, 0.5],
  [17, 0.25],
  [18, 0.125],
  [19, 0.125],
  [20, 0.25],

  // nuevos salcedo
  [90, 0.125],
  [89, 0.125],
  [88, 0.25],
  [87, 0.5],
  [86, 0.5],
  [85, 0.25],
  [84, 0.25],
  [83, 0.5],
  [82, 0.25],
  [81, 0.5]
];

const pollos = new Map();

pollosProp.map((row) => {
  pollos.set(row[0], row[1]);
});

const categories = [1, 2, 3, 4, 5, 11];

export { pollos, categories };
